import React from 'react';
import AppLoading from '../components/AppLoading';
import { PagesCommonProps } from '../helpers/pagesUtil';
import SummaryCardContainer from '../components/SummaryCardsContainer';
import { mergeChartConfigWithApiData } from '../helpers/chartConfigHelper';
import { dashboardGraphsOptions, GOOGLE_CHARTS_TYPES } from '../consts/graphs';
import ChartContainer, { ChartContainerProps } from '../components/Charts/ChartContainer';
import useFetchDashboard4Data from '../hooks/fetchDataComponents/useFetchDashboard4Data';

const { AREACHART, BAR } = GOOGLE_CHARTS_TYPES;

const Page4DashboardGraphs: React.FC<PagesCommonProps> = ({ filters, graphs = [] }) => {
  const { isLoadingMap, data, onScroll, exportActions, endpointsMap } = useFetchDashboard4Data({ filters, graphs });

  if (isLoadingMap?.fetchSummaryCardsData) return <AppLoading />;

  const baseChartsConfig: ChartContainerProps[] = [
    {
      onScroll,
      boxWidth: "45%",
      chartType: BAR,
      title: 'Logins by Month',
      chartId: "fetchLoginsByMonthData",
      options: dashboardGraphsOptions.BarChartOptions.GetByColumnLength(data?.fetchLoginsByMonthData?.data?.[0]),
    },
    {
      onScroll,
      boxWidth: "45%",
      chartType: BAR,
      title: 'Logins by Day',
      chartId: "fetchLoginsByDayData",
      options: dashboardGraphsOptions.BarChartOptions.GetByColumnLength(data?.fetchLoginsByDayData?.data?.[0]),
    },
    {
      onScroll,
      boxWidth: "95%",
      chartType: AREACHART,
      title: 'Logins by Time',
      chartId: "fetchLoginsByTimeData",
      options: {
        ...dashboardGraphsOptions.BarChartOptions.GetByColumnLength(
        data?.fetchLoginsByTimeData?.data?.[0],
      ),
        isStacked: false,
      }
    },/*
    {
      onScroll,
      boxWidth: "45%",
      chartType: TABLE,
      title: 'Logged-in Users',
      chartId: "fetchLoggedInUsersData",
      data: data?.fetchLoggedInUsersData?.data,
      isLoading: isLoadingMap?.fetchCourseCompletionByMonthData,
      options: dashboardGraphsOptions.TableChartOptions,
    },
    {
      onScroll,
      boxWidth: "45%",
      chartType: TABLE,
      title: 'Active Users with No Logins',
      chartId: "fetchActiveUsersWithNoLoginData",
      data: data?.fetchActiveUsersWithNoLoginData?.data,
      isLoading: isLoadingMap?.fetchCourseCompletionByMonthData,
      options: dashboardGraphsOptions.TableChartOptions,
    },*/
  ];

  // Merge base configuration with API data and filter/sort
  const ChartsListData: ChartContainerProps[] = mergeChartConfigWithApiData(baseChartsConfig, graphs);

  return (
    <>
      <SummaryCardContainer summaryCardsData={data?.fetchSummaryCardsData?.data as any} />
      
      <div className="charts-container">
        {ChartsListData.map((props, idx) => {
          const chartId = props.chartId;
          if (!chartId) return null;
          return (
            <ChartContainer 
              {...props} 
              key={idx} 
              index={idx}
              queryParams={filters}
              exportActions={exportActions}
              data={data?.[chartId as keyof typeof data]?.data}
              total={data?.[chartId as keyof typeof data]?.total}
              endpoint={endpointsMap?.[chartId as keyof typeof endpointsMap]}
              isLoading={isLoadingMap?.[chartId as keyof typeof isLoadingMap]}
            />
          );
        })}
      </div>
    </>
  );
};

export default Page4DashboardGraphs;
